<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_LABEL_STATEMENTS_DIALOG_CAPTION_ARCHIVING"
        :close="closeDialog"
        :alvqa="alvqa"
        maxCardHeight="600"
        maxDialogWidth="700"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row v-if="checkIfSomeRowsNotArchivable">
                    <v-col :alvqa="alvqa + 'warning-text'" class="text-center">
                        {{ $t('lang_LABEL_STATEMENTS_ARCHIVING_WARNING_NO_RESULTS')}} <br /> <br />
                        {{ getNameOfNotArchivableStatements() }}
                    </v-col>
                </v-row>
                <v-row v-if="checkIfNoneAreArchivable">
                    <v-col :alvqa="alvqa + 'close-text'" class="text-center">
                        {{ $t('lang_GENERAL_DIALOG_TEXT_CLOSE_DIALOG') }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        v-if="!checkIfNoneAreArchivable"
                        :alvqa="alvqa + '-text'" 
                        class="text-center"
                        v-html="getDialogText"
                    ></v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="addTag"
                            :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                            hide-details
                            :alvqa="alvqa + '-textfield-add-tag'"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="d-flex justify-end pl-0 pt-0" align-self="center">
                            <v-progress-circular v-if="archivingIsInProgress"
                                class="mr-5" 
                                :alvqa="alvqa + '-progress-bar'"
                                indeterminate
                                color="dialogProgressbar"
                            ></v-progress-circular>
                            <BaseButton 
                                :disabled="checkIfNoneAreArchivable||archivingIsInProgress"
                                :label="getButtonLabel"
                                @click="archive"
                                :alvqa="alvqa + '-button-save'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "LabelStatementsArchivingDialog",
    data() {
        return {
            alvqa: "label-statements-archiving-dialog",
        }
    },
    components: {
        BaseDialog,
        BaseButton
    },
    computed: {
        addTag: {
            get() { return this.$store.getters.getAddTag },
            set(tag) { 
                if (tag != null) {
                    this.$store.commit('setAddTag', tag.replace(/\s/g, ''))
                } else {
                    this.$store.commit('setAddTag', null)
                }
            }
        },
        showDialog: {
            get() { return this.$store.getters.getShowLabelStatemtensArchivingDialog },
            set(show) { this.$store.commit('setShowLabelStatemtensArchivingDialog', show) }
        },
        archivingIsInProgress(){
            return this.$store.getters.getArchivingInProgress
        },
        getButtonLabel() {
            let actionValue = this.$store.getters.getSelectedLabelStatementsAction
            let langConst = ''

            if(actionValue === 'archiveWithForwarded') langConst = 'lang_GENERAL_CAPTION_ARCHIVE_WITH_CARRY_FORWARD'
            if(actionValue === 'archiveWithoutForwarded') langConst = 'lang_GENERAL_CAPTION_ARCHIVE_WITHOUT_CARRY_FORWARD'

            return langConst
        },
        getDialogText() {
            let dialogText = this.$t('lang_LABEL_STATEMENTS_ARCHIVING_DIALOG_TEXT')

            dialogText = dialogText.replace(/<archiving>/gi, matched => {
                return {
                    '<archiving>': this.$t(this.getButtonLabel)
                }[matched]
            })

            return dialogText
        },

        checkIfNoneAreArchivable() {
            let selectedStatements = this.getSelectedStatementsDetails()
            return selectedStatements.every(statement => statement.archivable === 'no')
        },
        checkIfSomeRowsNotArchivable() {
            let selectedStatements = this.getSelectedStatementsDetails()
            return selectedStatements.some(statement => statement.archivable === 'no')
        },
        
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedLabelStatementsAction', [])
            this.$store.commit('setAddTag', null)
        },
        archive() {
            this.$store.dispatch('archiveLabelStatements')
        },

        getSelectedStatementsDetails() {
            let selectedStatementsAlvIds = this.$store.getters.getSelectedLabelStatements
            let allStatements = this.$store.getters.getLabelStatements
            let statementsDetailsArray = []

            selectedStatementsAlvIds.forEach(alvId => {
                let match = allStatements.find(statement => {
                    return alvId === statement.alvId
                })

                statementsDetailsArray.push(match)
            })

            return statementsDetailsArray
        },

        getNameOfNotArchivableStatements() {
            let selectedStatements = this.getSelectedStatementsDetails()
            let namesOfNotArchivableStatements = []

            selectedStatements.forEach(statement => {
                if(statement.archivable === 'no') { 
                    namesOfNotArchivableStatements.push(this.$alvPlugin.getArtistOrPerformerName(statement.licensor))
                }
            }) 

            return namesOfNotArchivableStatements.join(', ')
        },
    },
}
</script>